import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCredentialsId } from '@ovpn-ui-toolkit/mf-common';

import { pushToDataLayer } from '../utils';

const isUuidLike = (part: string): boolean => {
    /** Case for user IDs */
    if (part.includes('@') || part.includes('%40')) {
        return true;
    }

    return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
        part,
    );
};

const replaceDynamicUrlParams = (pathname: string) =>
    pathname
        .split('/')
        .map(part => {
            if (isUuidLike(part)) {
                return ':id';
            }

            return part;
        })
        .join('/');

/**
 * Hook to track custom data analytics events
 */
export default function useDataTracking() {
    const userId = useSelector(selectCredentialsId);
    const location = useLocation();
    const pathname = location.pathname;

    const trackEvent = useCallback(
        (...events: Record<string, unknown>[]) => {
            for (const event of events) {
                pushToDataLayer({
                    user_id: userId,
                    page_url: replaceDynamicUrlParams(pathname),
                    ...event,
                });
            }
        },
        [userId, pathname],
    );

    return trackEvent;
}
